<template>
  <div>
    <DetailsDialog ref="detailsDialog" />

    <GenericReport
      ref="report"
      class="maxh-2bar"
      hide-header
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :extraParams="{ vehicleIds: value.syntheticVid }"
      @rowClicked="showRowDetails"
    />
  </div>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from '../rdevents-history/rdevents-columns'
import DetailsDialog from '../rdevents-history/DetailsDialog'

export default {
  tabTitle: 'Eventos',
  tabGroup: 'Veículo',
  components: {
    GenericReport,
    DetailsDialog
  },
  props: {
    value: { required: true }
  },
  data() {
    return { adapterSpec: fullSpec }
  },
  computed: {
    reportSpec() {
      return {
        code: 'rawdataEvents',
        title: 'Eventos',
        apiBase: '/rawdata-events',
        filters: [
          'DateRange',
          { type: 'RDEventType', prefix: 'types', noSuffix: true },
          { type: 'Keywords', prefix: 'str0', label: 'str0' },
          { type: 'Keywords', prefix: 'str1', label: 'str1' }
        ]
      }
    }
  },
  methods: {
    showRowDetails({ row }) {
      this.$refs.detailsDialog.open(row.id)
    }
  }
}
</script>

<style></style>
